module.exports = __webpack_public_path__ + "923a32ee4e74efb120bc0315310d0026.png";